/* eslint-disable padding-line-between-statements */
/* eslint-disable camelcase */
/* eslint-disable no-else-return */
/* eslint-disable no-underscore-dangle */

import { Config } from 'configs';
import { getTranslatedData } from 'locales';
import { formatMillisToDateString } from './dateManagement';

/* eslint-disable no-restricted-syntax */
export const findProductCategoriesInHierarchy = (cats, productCategoryId, parentCat) => {
  if (!cats) {
    return null;
  }

  if (!productCategoryId) {
    return null;
  }

  for (const cat of cats) {
    if (cat._id === productCategoryId) {
      return cat;
    }

    const found = findProductCategoriesInHierarchy(cat?.parents, productCategoryId, cat);

    if (found) {
      return parentCat;
    }
  }

  return null;
};

export const renderProductCategory = (cats, productAssignedCategories) => {
  if (!cats) {
    return null;
  }

  if (!productAssignedCategories || productAssignedCategories.length === 0) {
    return null;
  }

  let moreThanOneCategoryAssigned = false;

  if (productAssignedCategories.length > 1) {
    moreThanOneCategoryAssigned = true;
  }

  const firstProductCategoryAssigned = productAssignedCategories[0];

  const productCategoriesObj = findProductCategoriesInHierarchy(
    cats,
    firstProductCategoryAssigned?.id,
    null,
  );

  if (!productCategoriesObj) {
    return null;
  }

  const suffix = moreThanOneCategoryAssigned ? ' ...' : '';

  const { name, parents } = productCategoriesObj;

  if (!parents || parents.length === 0) {
    return `${name}${suffix}`;
  }

  const parentNames = parents.map((parent) => parent.name).join(' > ');

  return `${name} -> ${parentNames}${suffix}`;
};

export const renderProductCategoryWithParents = (productCategory, joinSymbol) => {
  if (!productCategory) {
    return null;
  }

  const joinWith = joinSymbol || '';

  const { name, parents } = productCategory;

  if (!parents || parents.length === 0) {
    return `${getTranslatedData(name)}`;
  }

  const parentNames = [...parents]
    .reverse()
    .map((parent) => getTranslatedData(parent.name))
    .join(joinWith);

  return `${parentNames}${joinWith}${getTranslatedData(name)}`;
};

export const enrichProductCategoriesResponse = (categories) => {
  return categories?.map((productCategory) => {
    const pc = productCategory;

    pc.joinedName = renderProductCategoryWithParents(productCategory)?.replace(/ /g, '');
    pc.displayName = renderProductCategoryWithParents(productCategory, ' -> ');
    return pc;
  });
};

export const sortByRootParent = (a, b) => {
  return a.joinedName.localeCompare(b.joinedName);
};

export const getLocalTimeFromNumber = (localTimeNumber) => {
  const localTime = new Date(
    `2022-01-01 ${String(Math.floor(localTimeNumber / 60)).padStart(2, '0')}:${String(
      Math.floor(localTimeNumber % 60),
    ).padStart(2, '0')}:00`,
  );

  return `${localTime.getHours().toString().padStart(2, '0')}:${localTime
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
};

export const renderTime = (pricingModel) => {
  let hasDateFrom = false;
  let hasDateTo = false;
  let hasTimeFrom = false;
  let hasTimeTo = false;

  let dateFrom = '';
  let dateTo = '';
  let timeFrom = '';
  let timeTo = '';

  if (pricingModel.from) {
    dateFrom = formatMillisToDateString(pricingModel.from);
    hasDateFrom = true;
  }

  if (pricingModel.daily_from) {
    timeFrom = getLocalTimeFromNumber(pricingModel.daily_from);
    hasTimeFrom = true;
  }

  if (pricingModel.until) {
    dateTo = formatMillisToDateString(pricingModel.until);
    hasDateTo = true;
  }

  if (pricingModel.daily_to) {
    timeTo = getLocalTimeFromNumber(pricingModel.daily_to);
    hasTimeTo = true;
  }

  // 10:00 - 20:00 (2022-01-01 - 2022-05-05)
  if (hasTimeFrom && hasTimeTo && hasDateFrom && hasDateTo) {
    return `${timeFrom} - ${timeTo} (${dateFrom} - ${dateTo})`;
  }

  // From 12:00 (2022-01-01 - 2023-01-01)
  if (hasTimeFrom && !hasTimeTo && hasDateFrom && hasDateTo) {
    return `From ${timeFrom} (${dateFrom} - ${dateTo})`;
  }

  // To 20:00 (Until 2023-01-01)
  if (!hasTimeFrom && hasTimeTo && !hasDateFrom && hasDateTo) {
    return `To ${timeTo} (Until ${dateTo})`;
  }

  // 2022-01-01 - 2023-01-04
  if (!hasTimeFrom && !hasTimeTo && hasDateFrom && hasDateTo) {
    return `${dateFrom} - ${dateTo}`;
  }

  // 12:00 - 20:00
  if (hasTimeFrom && hasTimeTo && !hasDateFrom && !hasDateTo) {
    return `${timeFrom} - ${timeTo}`;
  }

  return 'All time';
};

export const renderPricingModelType = (pricingModel) => {
  let columnTitle = '';

  const getDiscountTitle = () => {
    if (pricingModel.fixed || pricingModel.percent) {
      let amountTitle = '';

      if (pricingModel.fixed) {
        amountTitle = `${pricingModel.fixed} €`;
      }

      if (pricingModel.percent) {
        amountTitle = `${pricingModel.percent}%`;
      }

      return amountTitle;
    }

    return null;
  };

  const amountTitle = getDiscountTitle();

  // Coupons
  if (pricingModel.type === 'Coupon') {
    columnTitle = `Coupon: ${pricingModel.coupon}`;

    if (amountTitle) {
      columnTitle = `${columnTitle} (${amountTitle})`;
    }

    return columnTitle;
  }

  // Discounts
  if (pricingModel.is_cart) {
    const amount = pricingModel.cart_total_over
      ? `${pricingModel.cart_total_over}  €`
      : amountTitle;

    return `${amount} from the whole cart`;
  }

  // Statics
  columnTitle = pricingModel.fixed ? 'Pricing' : 'Promotion';

  if (amountTitle) {
    columnTitle = `${columnTitle} (${amountTitle})`;
  }

  return columnTitle;
};

export const renderDiscountAmount = (pricingModel) => {
  const getDiscountTitle = () => {
    if (pricingModel.fixed || pricingModel.percent) {
      let amountTitle = '';

      if (pricingModel.fixed) {
        amountTitle = `${pricingModel.fixed} €`;
      }

      if (pricingModel.percent) {
        amountTitle = `${pricingModel.percent}%`;
      }

      return amountTitle;
    }

    return null;
  };

  const amountTitle = getDiscountTitle();

  // Discounts
  if (pricingModel.is_cart) {
    const amount = pricingModel.cart_total_over
      ? `${pricingModel.cart_total_over}  €`
      : amountTitle;

    return `${amount} from the whole cart`;
  }

  return amountTitle;
};

export const renderPaymentTotal = (payment, discount) => {
  const {
    cart_price,
    tips_price,
    priority_price,
    discount: discountFromPayment,
  } = payment || {
    cart_price: 0,
    tips_price: 0,
    priority_price: 0,
  };

  return (
    (cart_price || 0) +
    (tips_price || 0) +
    (priority_price || 0) +
    -1 * (-1 * discountFromPayment || discount || 0)
  );
};
export const renderOrderTotal = (order) => {
  let total = 0;

  order?.payments?.forEach((payment) => {
    if (payment?.type === Config.DATA.ORDER_LINE_TYPES.REFUND) {
      total -= payment.cart_price || 0;
    } else if (payment?.type === Config.DATA.ORDER_LINE_TYPES.PRIORITY) {
      total += payment.cart_price || 0;
    } else {
      total += renderPaymentTotal(payment);
    }
  });

  return total;
};

export const renderOrdersTotal = (clientsOrders) => {
  let total = 0;

  clientsOrders?.forEach((order) => {
    total += renderOrderTotal(order);
  });

  return total;
};

export const extractRecordsFromAggreagte = (response) => {
  const responseFromAggregate = response;

  if (responseFromAggregate && responseFromAggregate.length > 0) {
    const data = responseFromAggregate[0];

    if (data) {
      const { paginatedResults, totalCount } = data || {
        paginatedResults: [],
        totalCount: 0,
      };

      return {
        paginatedResults,
        totalCount,
      };
    }
  }

  return {
    paginatedResults: [],
    totalCount: 0,
  };
};

export const extractRecordsFromFullArray = (response, currentPage, perPage) => {
  if (!response || response.length === 0) {
    return {
      paginatedResults: [],
      totalCount: 0,
    };
  }

  const fromInd = (currentPage - 1) * perPage;
  let toInd = fromInd + perPage;

  if (fromInd >= response.length) {
    return {
      paginatedResults: [],
      totalCount: response.length,
    };
  }

  if (toInd > response.length) {
    toInd = response.length;
  }

  const paginatedResults = response.slice(fromInd, toInd);

  return {
    paginatedResults,
    totalCount: response.length,
  };
};

export const formatFullRestaurantAddress = (restaurant) => {
  const toJoin = [];
  if (restaurant.street) {
    toJoin.push(restaurant.street);
  }

  if (restaurant.city) {
    toJoin.push(restaurant.city);
  }

  if (restaurant.zip) {
    toJoin.push(restaurant.zip);
  }

  return toJoin.join(', ');
};
